import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'matchmaking-form-option-list',
    imports: [],
    templateUrl: './form-option-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './form-option-list.component.scss'
})
export class FormOptionListComponent {}
